import dynamic from 'next/dynamic'

export const Blog = {
    Blogs: dynamic(() => import('./Blogs')),
    FeaturedBlog: dynamic(() => import('./FeaturedBlog')),
    SearchBar: dynamic(() => import('./SearchBar')),
    CategoryBar: dynamic(() => import('./CategoryBar')),
    Pagination: dynamic(() => import('./Pagination')),
}
